import { useAppSelector } from '../store';

export function useActiveOrganisation() {
    const { activeOrganisation } = useAppSelector((state) => state.security);

    return activeOrganisation;
}
